import { render, staticRenderFns } from "./adhdReport.vue?vue&type=template&id=e383dbd2&"
import script from "./adhdReport.vue?vue&type=script&lang=js&"
export * from "./adhdReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports